<template>
  <div class="app-container">
    <div>
      <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form-inline">
        <el-form-item>
          <el-input
            v-model="searchForm.key"
            :placeholder="generateCustomizeString('goodsName')"
            resize="horizontal"
            style="width: 152px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.bar_code"
            :placeholder="generateCustomizeString('barcode')"
            resize="horizontal"
            style="width: 155px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-cascader
            placeholder="商品分类"
            expand-trigger="hover"
            :options="categoriesOptions"
            v-model="searchForm.selectCategory"
            @change="handleChange"
            change-on-select
            clearable
            style="width: 155px;"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchForm.brand_id"
            placeholder="商品品牌"
            filterable
            clearable
            style="width: 155px;"
          >
            <el-option
              v-for="item in brandOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="order_by"
            placeholder="价格排序"
            @change="orderSortClick"
            style="width: 155px;"
          >
            <el-option
              v-for="item in orderByOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">{{ generateCustomizeString('search') }}</el-button>
          <el-button @click="onReset">{{ generateCustomizeString('reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-bottom: 10px;">
      <el-button size="medium" @click="updateSelectDiscount">批量修改定价方案</el-button>
      <el-button size="medium" @click="updateSelectIsSold">批量修改商品上架</el-button>
      <el-button size="medium" @click="updateSelectIsNotSold">批量修改商品下架</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="goodsData"
      v-loading="listLoading"
      :element-loading-text="generateCustomizeString('loading')"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
      style="margin-bottom: 20px;"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="SPU" prop="product_spu_unique" align="center"></el-table-column>
      <el-table-column label="产品" prop="product_name" align="center"></el-table-column>
      <el-table-column label="成本" prop="min_cost_price" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.min_cost_price !== scope.row.max_cost_price"
          >{{ scope.row.min_cost_price | formatPrice }}起</span>
          <span v-else>{{ scope.row.min_cost_price | formatPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="定价方案" align="center" width="120">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.discount_name }}</el-tag>
          <br />
          <span>{{ scope.row.target_profit }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="销售价格" align="center" width="120">
        <template slot-scope="scope">
            <span>{{ scope.row.discount_name }}</span>
        </template>
      </el-table-column>-->
      <el-table-column :label="generateCustomizeString('goodsImage')" align="center" width="140">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.image_url" alt style="width: 60px;"> -->
          <el-popover placement="top" width="420" v-model="scope.row.popoverVisible">
            <div style="text-align: center; width: 100%; margin: 0 auto;">
              <!-- <img :src="qrcode"> -->
              <img :id="scope.row.id" src />
            </div>
            <div slot="reference" @click="createQrcode(scope.row)">
              <img :src="scope.row.image_url" style="width: 50px;" />
              <img
                src="/img/qrcodeIcon.png"
                style="width: 20px;position: absolute;right: 25%;bottom: 28%;"
              />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="是否上架" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.agent_info.is_sold" @change="editGoodsStatus(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('operation')" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click.native.prevent="editProduct(scope.$index)"
          >修改</el-button>
          <!-- </div> -->
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;">
      <el-button size="medium" @click="updateSelectDiscount">批量修改定价方案</el-button>
      <el-button size="medium" @click="updateSelectIsSold">批量修改商品上架</el-button>
      <el-button size="medium" @click="updateSelectIsNotSold">批量修改商品下架</el-button>
    </div>
    <el-footer style="margin-top: 50px; width: 100%;">
      <el-row type="flex">
        <el-col>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfGoods"
            :total="currentTotal"
            small
            background
            layout="prev, pager, next"
            v-if="isMobile === true"
          ></el-pagination>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfGoods"
            :total="currentTotal"
            small
            background
            layout="total, prev, pager, next"
            v-else
          ></el-pagination>
        </el-col>
      </el-row>
      <div style="margin-top: 10px;">
        <span style="font-size: 14px; color: #606266;">每页商品数：</span>
        <el-select
          v-model="numOfGoods"
          size="mini"
          style="width: 80px;"
          @change="selectNumOfGoods()"
        >
          <el-option
            v-for="item in numOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </el-footer>

    <!-- 弹出修改框 -->
    <el-dialog title="定价方案" :visible.sync="dialogTableVisible">
      <el-form :model="form">
        <el-form-item label="方案" label-width="100px">
          <el-radio v-model="customizePricePlan" label="1">百分比方案</el-radio>
          <el-radio v-model="customizePricePlan" label="2">加价方案</el-radio>
        </el-form-item>
        <el-form-item label="百分比方案" label-width="100px" v-if="this.customizePricePlan == 1">
          <el-select v-model="discount_name" placeholder="Please select a plan">
            <el-option
              v-for="item in discountPlanData"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加价方案" label-width="100px" v-if="this.customizePricePlan == 2">
          <el-input-number v-model="target_profit" :precision="2" :step="0.1" :max="100" :min="0.1"></el-input-number>
          <span style="margin-left: 8px;">最高加价NZ$100.00</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">Cancel</el-button>
        <el-button type="primary" @click="changeDiscountPlan()">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量修改销售方案" :visible.sync="selectionDialogVisible">
      <el-form :model="form">
        <el-form-item label="方案" label-width="100px">
          <el-radio v-model="customizePricePlan" label="1">百分比方案</el-radio>
          <el-radio v-model="customizePricePlan" label="2">加价方案</el-radio>
        </el-form-item>
        <el-form-item label="百分比方案" label-width="100px" v-if="this.customizePricePlan == 1">
          <el-select v-model="discount_name" placeholder="Please select a plan">
            <el-option
              v-for="item in discountPlanData"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加价方案" label-width="100px" v-if="this.customizePricePlan == 2">
          <el-input-number v-model="target_profit" :precision="2" :step="0.1" :max="100" :min="0.1"></el-input-number>
          <span style="margin-left: 8px;">最高加价NZ$100.00</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectionDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateSelectDiscountPlan()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import QRCode from 'qrcode'

const originOrderSearchFrom = {
  key: '',
  bar_code: '',
  selectCategory: [],
  brand_id: ''
}

export default {
  name: 'GoodsList',
  data() {
    return {
      mobileUrl: process.env.VUE_APP_MOBILE_URL,
      listLoading: true,
      discountPlanData: [],
      searchForm: Object.assign({}, originOrderSearchFrom),
      isMobile: false,
      goodsData: [],
      popoverVisible: false,
      numOfGoods: 15,
      currentPage: 1,
      currentTotal: 0,
      filters: {},
      dialogTableVisible: false,
      discount_name: '',
      product_id: 0,
      form: {
        region: ''
      },
      qrcode: '',
      goodsImg: '',
      selectionDialogVisible: false,
      selections: [],
      multipleSelection: [],
      select_discount: '',
      categoriesOptions: [],
      brandOptions: [],
      order_by: '',
      order_turn: '',
      orderByOptions: [
        {
          value: 'min_price',
          label: '价格从低到高'
        },
        {
          value: 'max_price',
          label: '价格从高到低'
        }
      ],
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        }
      ],
      customizePricePlan: '1',
      target_profit: 1
    }
  },
  computed: {
    shopDomainPrefix() {
      return this.$store.state.shop.shop_domain_prefix
    }
  },
  created() {
    Promise.all([
      this.fetchDiscountPlan(),
      this.fetchCategories(),
      this.fetchBrand()
    ])
      .then(result => {
        this.fetchProductList(1)
        this.checkMobile()
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    generateCustomizeString,
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          params.category_id =
            params.selectCategory.length === 2
              ? params.selectCategory[1]
              : params.selectCategory[0]
          delete params.selectCategory
          this.filters = params
          this.fetchProductList(1)
        }
      })
    },
    handleChange(value) {
      console.log(value)
    },
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    selectNumOfGoods() {
      this.fetchProductList(1)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleCurrentChange(val) {
      this.fetchProductList(val)
    },
    orderSortClick() {
      if (this.order_by === 'min_price') {
        this.order_turn = 'asc'
      } else if (this.order_by === 'max_price') {
        this.order_turn = 'desc'
      }
      this.fetchProductList(this.currentPage)
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: 'categories',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].name
              const sub = response.data[i].sub_categories
              for (let j = 0; j < response.data[i].sub_categories.length; j++) {
                var sobj = {}
                sobj.value = response.data[i].sub_categories[j].id
                sobj.label = response.data[i].sub_categories[j].name
                sub[j] = sobj
              }
              obj.children = sub
              data[i] = obj
            }
            this.categoriesOptions = data
            this.categoriesOptions.unshift({ label: '全部', value: null })
            console.log(this.categoriesOptions)
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchBrand() {
      return new Promise((resolve, reject) => {
        request({
          url: 'brands?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].brand_name
              data[i] = obj
            }
            this.brandOptions = data
            this.brandOptions.unshift({ label: '全部', value: null })
            console.log(this.brandOptions)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchProductList(page) {
      return new Promise((resolve, reject) => {
        this.listLoading = true
        request({
          url: 'goods-list',
          method: 'get',
          params: {
            page: page,
            order_by: this.order_by,
            order_turn: this.order_turn,
            ...this.filters,
            page_size: this.numOfGoods
          }
        })
          .then(res => {
            if (res.status === 0) {
              const meta = res.meta
              this.goodsData = res.data
              for (let i = 0; i < this.goodsData.length; i++) {
                this.goodsData[i].popoverVisible = false
                if (this.goodsData[i].images.length > 0) {
                  this.goodsData[i].image_url = this.goodsData[
                    i
                  ].images[0].image_url
                }
                // 匹配折扣方案名字
                for (let h = 0; h < this.discountPlanData.length; h++) {
                  if (this.goodsData[i].agent_info.target_profit !== null) {
                    // 自主加价方案有优先级
                    this.goodsData[i].discount_name = '自主加价'
                    this.goodsData[i].target_profit =
                      '$' +
                      (
                        this.goodsData[i].agent_info.target_profit / 100
                      ).toFixed(2)
                  } else if (
                    this.goodsData[i].agent_info.agent_plan_id ===
                    this.discountPlanData[h].id
                  ) {
                    // 否则就是用百分比方案
                    this.goodsData[i].discount_name = this.discountPlanData[
                      h
                    ].name
                    this.goodsData[i].target_profit =
                      'from ' +
                      this.discountPlanData[h].level_discounts[0].discount *
                        100 +
                      '%'
                  }
                }
              }
              this.currentPage = meta.current_page
              this.currentTotal = meta.total
            }
            this.listLoading = false
          })
          .catch(error => {
            console.error(error)
            this.listLoading = false
          })
      })
    },
    fetchDiscountPlan() {
      return new Promise((resolve, reject) => {
        request({
          url: 'discount/plan/list',
          methods: 'get'
        })
          .then(res => {
            if (res.status === 0) {
              this.discountPlanData = res.data
              console.log(this.discountPlanData)
              resolve(res)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    editProduct(index) {
      this.discount_name = this.goodsData[index].discount_name
      this.product_id = this.goodsData[index].id
      this.dialogTableVisible = true
    },
    changeDiscountPlan() {
      this.dialogTableVisible = false
      let params = {}
      if (this.customizePricePlan == 1) {
        params = {
          target_profit: null,
          agent_plan_id: this.getDiscountId(this.discount_name)
        }
      } else {
        params = { target_profit: (this.target_profit * 1000) / 10 }
      }
      // const discount_id = this.getDiscountId(this.discount_name)
      request({
        url: '/agent/goods/' + this.product_id,
        method: 'patch',
        data: params
      })
        .then(res => {
          if (res.status === 0) {
            this.$message.success({
              message: '商品销售方案更改成功',
              center: true
            })
            this.fetchProductList(this.currentPage)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    editGoodsStatus(row) {
      request({
        url: '/agent/goods/' + row.id,
        method: 'patch',
        params: {
          is_sold: row.agent_info.is_sold
        }
      })
        .then(res => {
          if (res.status === 0) {
            if (row.agent_info.is_sold === true) {
              this.$message({
                message: '商品上架成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: '商品下架成功',
                type: 'success'
              })
            }
          } else {
            this.$message.error('商品状态操作失败')
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('商品状态操作失败')
        })
    },
    getDiscountId(discountName) {
      const that = this
      for (let i = 0; i < that.discountPlanData.length; i++) {
        if (that.discountPlanData[i].name === discountName) {
          return that.discountPlanData[i].id
        }
      }
    },
    createQrcode(row) {
      const qrcodeLink =
        this.mobileUrl + this.shopDomainPrefix + '/goodDetail/' + row.id
      row.popoverVisible = true

      QRCode.toDataURL(qrcodeLink)
        .then(url => {
          this.qrcode = url
          var img = url

          var canvas = document.createElement('canvas')
          canvas.width = 400
          canvas.height = 400
          var context = canvas.getContext('2d')

          context.rect(0, 0, canvas.width, canvas.height)
          context.fillStyle = '#fff'
          context.fill()

          var myImage = new Image()
          myImage.setAttribute('crossOrigin', 'anonymous')
          myImage.src = row.image_url
          // myImage.crossOrigin = 'Anonymous'
          var myImage2 = new Image()
          myImage2.setAttribute('crossOrigin', 'anonymous')
          myImage2.src = img
          // myImage2.crossOrigin = 'Anonymous'

          myImage.onload = function() {
            context.drawImage(
              myImage,
              0,
              0,
              400,
              (400 * myImage.height) / myImage.width
            )
            context.drawImage(myImage2, 300, 300, 100, 100)
            var base64 = canvas.toDataURL('image/png')
            this.goodsImg = base64

            var image = document.getElementById(row.id)
            image.setAttribute('src', base64)
            // document.getElementById('avatar').src = base64
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    onReset() {
      this.order_by = ''
      this.order_turn = ''
      this.searchForm.key = ''
      this.searchForm.bar_code = ''
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originOrderSearchFrom)
      this.filters = {}
      this.fetchProductList(1)
    },
    updateSelectDiscount() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info('请选择商品')
        return
      }
      this.selectionDialogVisible = true
      this.select_discount = ''
    },
    updateSelectDiscountPlan() {
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }
      let params = {}
      if (this.customizePricePlan == 1) {
        params = {
          agent_plan_id: this.getDiscountId(this.discount_name),
          target_profit: null
        }
      } else {
        params = {
          target_profit: (this.target_profit * 1000) / 10
        }
      }
      request({
        url: 'agent/goods/batch',
        method: 'patch',
        data: {
          ids: selectIds,
          data: params
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '批量修改销售方案成功',
              type: 'success'
            })
          } else {
            this.$message.error('批量修改销售方案失败')
          }
          this.selectionDialogVisible = false
          this.fetchProductList(this.currentPage)
        })
        .catch(error => {
          console.log(error)
          this.$message.error('批量修改销售方案失败')
          this.selectionDialogVisible = false
        })
    },
    updateSelectIsSold() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info('请选择商品')
        return
      }
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }

      var data = {
        is_sold: true
      }
      request({
        url: 'agent/goods/batch',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '批量修改商品上架成功',
              type: 'success'
            })
          } else {
            this.$message.error('批量修改商品上架失败')
          }
          this.fetchProductList(this.currentPage)
        })
        .catch(error => {
          console.log(error)
          this.$message.error('批量修改商品上架失败')
        })
    },
    updateSelectIsNotSold() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info('请选择商品')
        return
      }
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }

      var data = {
        is_sold: false
      }
      request({
        url: 'agent/goods/batch',
        method: 'patch',
        data: {
          ids: selectIds,
          data: data
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '批量修改商品下架成功',
              type: 'success'
            })
          } else {
            this.$message.error('批量修改商品下架失败')
          }
          this.fetchProductList(this.currentPage)
        })
        .catch(error => {
          console.log(error)
          this.$message.error('批量修改商品下架失败')
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.grid-content {
  min-height: 45px;
  margin: 0 auto;
  flex: auto;
  overflow: auto;
  -webkit-align-items: center;
  align-items: center;
}
.title-label {
  display: inline-block;
  text-align: right;
  width: 80px;
}
.content-label {
  padding: 0px 0px 0px 10px;
}
.price-tag {
  width: 120px;
  height: 35px;
  font-size: 14px;
  text-align: center;
  line-height: 35px;
}

.el-dialog {
  width: 40%;
}

@media only screen and (max-width: 576px) {
  .el-dialog {
    width: 90%;
  }
}
</style>
